import "antd/es/cascader/style";
import _Cascader from "antd/es/cascader";
var _excluded = ["className", "popupClassName", "expandIcon", "suffixIcon", "displayRender"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import classNames from 'classnames';
import { IconDownOutlined, IconRightOutlined } from '@osui/icons';
import './index.less';
var clsPrefix = 'osui-cascader';

var OSUICascader = function OSUICascader(_ref, ref) {
  var className = _ref.className,
      popupClassName = _ref.popupClassName,
      expandIcon = _ref.expandIcon,
      suffixIcon = _ref.suffixIcon,
      displayRender = _ref.displayRender,
      props = _objectWithoutProperties(_ref, _excluded);

  var innerClassName = classNames(clsPrefix, className);
  var innerDisplayRender = displayRender !== null && displayRender !== void 0 ? displayRender : function (label) {
    return label.map(function (item, index) {
      return index === label.length - 1 // 最后一个后面不加icon
      ? /*#__PURE__*/React.createElement("span", null, item) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, item), "\xA0>\xA0");
    });
  };
  var maxChildrenLength = React.useMemo(function () {
    var result = [];

    var getLength = function getLength(options) {
      if (!options) {
        return;
      }

      result.push(options.length);
      options.forEach(function (i) {
        return getLength(i.children);
      });
    };

    getLength(props.options);
    return Math.max.apply(Math, result);
  }, [props.options]); // 计算最多子数，不超过10，然后算最小高度 子数 * 30(item高度) + 8px(上下padding)，通过className处理
  // 因为style写不到

  var cascaderMinHeight = Math.min(maxChildrenLength, 10);
  var innerPopupClassName = classNames("".concat(clsPrefix, "-menu"), "".concat(clsPrefix, "-menu-").concat(cascaderMinHeight), popupClassName);
  var innerExpandIcon = expandIcon !== null && expandIcon !== void 0 ? expandIcon : /*#__PURE__*/React.createElement(IconRightOutlined, null);
  var innerSuffixIcon = suffixIcon !== null && suffixIcon !== void 0 ? suffixIcon : /*#__PURE__*/React.createElement(IconDownOutlined, null);
  return /*#__PURE__*/React.createElement(_Cascader, _objectSpread({
    ref: ref,
    className: innerClassName,
    displayRender: innerDisplayRender,
    popupClassName: innerPopupClassName,
    expandIcon: innerExpandIcon,
    suffixIcon: innerSuffixIcon,
    style: _objectSpread(_objectSpread({}, props.style), {}, {
      minHeight: cascaderMinHeight
    })
  }, props));
};

var RefCastCascader = /*#__PURE__*/React.forwardRef(OSUICascader);
hoistNonReactStatics(RefCastCascader, _Cascader);
export default RefCastCascader;
//# sourceMappingURL=index.js.map